import { render, staticRenderFns } from "./bottom-sheet-ayuda.vue?vue&type=template&id=2a09004e&scoped=true&"
import script from "./bottom-sheet-ayuda.vue?vue&type=script&lang=js&"
export * from "./bottom-sheet-ayuda.vue?vue&type=script&lang=js&"
import style0 from "./bottom-sheet-ayuda.vue?vue&type=style&index=0&id=2a09004e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a09004e",
  null
  
)

export default component.exports